import React from 'react';
import { Box, DialogActions } from '@mui/material';
import SubMatDialogFooterButton from './SubMatDialogFooterButton';

/**
 * theme.js 전역 스타일 덮어쓰기 + 서류보내기(SendMailDialog) medium 버튼과 동일 높이
 * - .MuiDialogActions-spacing { padding-left: 0 }
 * - .MuiDialogActions-root > button { font-size: 16px } → Box 내부 버튼도 동일 적용
 */
export const SUBMAT_TEMPLATE_DIALOG_ACTIONS_SX = {
  '&&': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    boxSizing: 'border-box',
    padding: '16px 24px 32px 16px !important',
    gap: 0,
  },
  '& .MuiButton-root': {
    fontSize: '16px !important',
    fontWeight: 500,
    width: 'auto',
    minWidth: 'unset !important',
    textTransform: 'none !important',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    lineHeight: 1.75,
    padding: '6px 16px !important',
  },
  '& .MuiButton-outlined': {
    borderWidth: '1px !important',
    padding: '5px 15px !important',
  },
  '& .MuiButton-contained': {
    boxShadow: 'none !important',
    '&:hover': {
      boxShadow: 'none !important',
    },
  },
  '& .MuiButton-startIcon': {
    marginRight: '8px !important',
    marginLeft: '-4px !important',
  },
  '& .MuiButton-startIcon > *:nth-of-type(1)': {
    fontSize: '20px !important',
  },
};

/**
 * 템플릿 수정·발송 다이얼로그 하단 — PDF 좌 / (이전·다음·저장) 우, 버튼 크기·폰트 통일.
 * @param {React.ReactNode} [beforePrimary] — 저장/다음 왼쪽에 둘 버튼(예: 이전)
 */
const SubMatTemplateDialogFooter = ({
  pdfButton,
  beforePrimary = null,
  primaryButton,
  onCancel,
  cancelDisabled,
}) => (
  <DialogActions disableSpacing sx={SUBMAT_TEMPLATE_DIALOG_ACTIONS_SX}>
    {pdfButton}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ml: 'auto',
      }}
    >
      {beforePrimary}
      {primaryButton}
      <SubMatDialogFooterButton onClick={onCancel} disabled={cancelDisabled}>
        닫기
      </SubMatDialogFooterButton>
    </Box>
  </DialogActions>
);

export default SubMatTemplateDialogFooter;
